"use strict";
(function (global) {

/**
* Базовый класс реквизита.
*
* @class WebAccess.components.wrappers.form.requisites.BaseRequisite
* @extends BaseObject
* @property {string} name Имя реквизита
* @property {string} calssName Имя класса
* @property {string} fullName Полное имя реквизита. Оставлено для совместимости
* @property {array} controlsIds Список ИД элементов управления
* @property {array} controls Список элементов управления
* @param {string} requisiteName Имя реквизита
  * @param {object|string} data Параметры элемента страницы, либо его селектор
*/
  var BaseRequisite = BaseObject.extend({
    className: "BaseRequisite",

    name: "",
    fullName: '',
    hasCalculation: false,

    controlsIds: [],
    controls: [],
    _isCalculationDisabled: false,
    _isNew: false,
    _isChanged: false,
    _isCommited: false,
    _isDisabled: null,
    _data: null,
    _parent: null,
    _referenceViewName: '',
    Init: null,
    // Список всех Init для всех контролов реквизита. От них зависит глобальное событие Init.
    _allControlsInit: null,
    //---------------------------------------------------------------------//

    init: function (requisiteName, data, opt_parent) {
      this.Init = $.Deferred();
      this._allControlsInit = [];

      if (!$.isPlainObject(data)) {
        var selector = data;
        data = {
          controls: [selector],
          displayValue: "",
          isRequired: false,
          isRendered: true,
          isReadOnly: false,
          isSystem: false,
          value: ""
        }
      }

      this._parent = opt_parent;

      if (typeof (data) == 'object') {
        this._data = data;
      } else {
        return this._super(requisiteName);
      };

      this.hasCalculation = data.hasCalculation;
      this.name = requisiteName;
      this.fullName = requisiteName;

      if (this._data.row_id && this._data.sectionNumber) {
        this.fullName = format("{0}${1}${2}", this._data.sectionNumber, this._data.row_id, this.fullName);
      };

      this.controlsIds = this._data.controls || [];
      this._type = data.type;
      this._referenceViewName = data.referenceView;

      this.controls = this._getControls();
      this._isDisabled = this.isDisabled();    
      this._super(this.controls, true);
      this._bindEvents();
      this._bindUnHighlightOnChange(); // Не в _bindEvents, т.к. _bindEvents переопределяется в других классах не вызывая родительский.
      this._isChanged = false;
      this._isCommited = false;
      this._raiseInitEvent();
    },

    /**
    * Генерирует событие инициализаии реквизита.
    * @private
    */
    _raiseInitEvent: function () {
      var me = this;

      $.when.apply(null, me._allControlsInit).then(function () {
        me.Init.resolve();
      });
    },
    //---------------------------------------------------------------------//

    /**
    * Инициализация снятия подсветки при изменении реквизита (#108403)
    * @private
    * @since 5.0.0.2008
    * @return WebAccess.components.wrappers.form.requisites.BaseRequisite
    */
    _bindUnHighlightOnChange: function () {
      var me = this;
      me.bind('change', me.unHighlight, me);
      return me;
    },

    /**
    * Признак отключения серверных вычислений на реквизите.
	  *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isCalculationDisabled
    * @return {boolean}
    * @since 5.2.0.2014
    */
    isCalculationDisabled: function () {
      return this._isCalculationDisabled;
    },

    /**
    * Возвращает представление справочника.
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#referenceViewName
    * @return {string} Строка, содержащая представление справочника.
	* @since 5.5.0.9023
    */
    referenceViewName: function () {
      return this._referenceViewName;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак, что реквизит системный.
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isSystem
    * @return {boolean} True – реквизит системный, иначе False.
	* @since 5.5.0.9000
    */
    isSystem: function () {
      return this._data.isSystem;
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает текст всплывающей подсказки.
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#setTooltip
	  * @param {string} value Текст всплывающей подсказки.
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.2014
    */
    setTooltip: function (value) {
      $('.tooltip[for="' + this.name + '"]').qtip('option', 'content.text', value);
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получает текст всплывающей подсказки.
  	*
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#getTooltip
    * @return {string} Текст всплывающей подсказки.
    * @since 5.2.0.2014
    */
    getTooltip: function () {
      var tooltip = $('.tooltip[for="' + this.name + '"]').qtip('option', 'content.text');
      return (!_.isString(tooltip)) ? '' : tooltip;
    },
    //---------------------------------------------------------------------//

    /**
    * Отключает серверные вычисления на реквизите.
	  *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#disableCalculation
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.2014
    */
    disableCalculation: function () {
      this._isCalculationDisabled = true;
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Включает серверные вычисления на реквизите.
	  *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#enableCalculation
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.2014
    */
    enableCalculation: function () {
      this._isCalculationDisabled = false;
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получает тип реквизита.
	*
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#getType
    * @return {REQUISITE_TYPE} Тип реквизита.
    * @since 5.2.0.2014
    */
    getType: function () {
      return requisiteTypeFromString(this._type) || this._type;
    },
    //---------------------------------------------------------------------//

    /**
    * @ignore
    */
    isNew: function () {
      return this._isNew;
    },
    //---------------------------------------------------------------------//

    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.BaseRequisite
    */
    _showSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        jControl.parent().append('<div class="circle-spinner refselect-input__spinner"></div>');
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит
    */
    _hideSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        jControl.parent().find('.circle-spinner').remove();
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Инициализация событий
    * @private
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindEvents
    * @since 5.0.0.7100
    * @return WebAccess.components.wrappers.form.requisites.BaseRequisite
    */
    _bindEvents: function () {
      if (this.controls.length === 0) return this;

      var me = this;
      _(me.controls).each(function (jControl) {
        me._bindControlEvents(jControl);
      });

      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * @private
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindControlEvents
    * @since 5.0.0.7100
    */
    _bindControlEvents: function (jControl) {
      var me = this;
      var reqFullName = me.fullName;

      jControl.off('change.BaseRequisite').on('change.BaseRequisite', function (ev) {
        var value = me.getValue($(this));
        var displayValue = me.getDisplayValue($(this));
        me._fireChange(reqFullName, value, displayValue, ev);
      });
    },
    //---------------------------------------------------------------------//

    /**
    * Вызвать событие изменения
    * @private
    */
    _fireChange: function (reqFullName, value, displayValue, opt_ev) {
      var me = this;
      me.touch();
      me.fire("change", this, opt_ev, { name: reqFullName, value: value, displayValue: displayValue });
    },

    /**
    * Получить контролы реквизита
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_getControls
    * @since 5.0.0.7100
    * @private
    * @return {array} список jquery объектов
    */
    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];
        var jControl = $('#' + id);
        res.push(jControl);
      }
      return res;
    },
    //---------------------------------------------------------------------//

    /**
    * Получает значение подписи для реквизита.
    *
    * @function WebAccess.components.wrappers.form.requisites.BaseRequisite#getLabel
    * @return {string} Строка, содержащая значение подписи для реквизита.
    * @since 5.0.0.7100
    */
    getLabel: function () {
      if (this.controls.length === 0) return null;
      var jLabel = this._getLabelForControl(this.controls[0]);
      return jLabel.text();
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает подпись для реквизита.
    *
    * @function  WebAccess.components.wrappers.form.requisites.BaseRequisite#setLabel
    * @param {string} text Текст подписи
    * @return {WebAccess.components.wrappers.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    setLabel: function (text) {
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        var jLabel = this._getLabelForControl(this.controls[0]);
        jLabel.text(text);
      }
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить контрол подписи.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_getLabelForControl
    * @private
    * @since 5.0.0.7100
    * @return {object}
    */
    _getLabelForControl: function (jControl) {
      var jC = jControl.parents('.Card_Element:first').prev('.CardForm_Label');
      if (jC.length) return jC;
      return jControl.parents('tr').eq(0).find('td.wizard-table__cell_type_label');
    },
    //---------------------------------------------------------------------//

    /**
    * Получает значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#getValue
    * @return {string} Строка, содержащая значение реквизита.
    * @since 5.0.0.7100
    */
    getValue: function (opt_jControl) {
      var value;
      if (this._data && this._data.isRendered === false) return this._data.value;
      var id;
      if (opt_jControl) id = opt_jControl.attr('id');
      value = this._getControlValue(id || this.controlsIds[0]);

      return value;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак видимости реквизита на форме.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isVisible
    * @return {boolean} True – реквизит отображается на форме, иначе False.
    * @since 5.0.0.7100
    */
    isVisible: function () {
      if (this.controls.length > 0) {
        return this.controls[0].css('visibility') === 'visible';
      }
      return false;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак наличия элементов управления для реквизита на форме.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isRendered
    * @return {boolean} True – для реквизита присутствуют элементы управления на форме, иначе False.
	* @since 5.5.0.9003
    */
    isRendered: function() {
      return this._data.isRendered;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак изменения реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isChanged
    * @return {boolean} True – реквизит был изменен, иначе False.
    * @since 5.0.0.7100
    */
    isChanged: function () {
      return this._isChanged;
    },

    /**
    * Признак, показывающий, были ли уже отправлены на сервер значения реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isCommited
    * @return {boolean} True – значение реквизита было отправлено, иначе False.
    * @since 5.7.0.1000
    */
    isCommited: function () {
      return this._isCommited;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить значение в поле по его имени.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_getControlValue
    * @since 5.0.0.7100
    * @private
    */
    _getControlValue: function (controlName) {
      var jControl = $("input#" + controlName); //
      if (jControl.data('requisite')) { //
        return jControl.data('requisite').val();
      };
      return jControl.val();
    },
    //---------------------------------------------------------------------//

    /**
    * Получает отображаемое значение реквизита.
    *
    * @fixme Не работает с детальными разделами.
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      if (this._data && this._data.isRendered === false) return this._data.displayValue;
      if (this.controls.length === 0) return;

      var displayValue = "";
      var jReq = opt_jControl || this.controls[0];

      displayValue = this.getValue(opt_jControl);
      return displayValue;
    },
    //---------------------------------------------------------------------//

    /**
    * Установка значений невидимых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_setInvisibleValues
    * @private
    * @param value {string} устанавливаемое значение
    * @param [opt_displayValue] {string} отображаемое значение
    * @param [opt_needTriggerResult] {string} вызывать триггер события change
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит
    * @since 5.0.0.7100
    */
    _setInvisibleValues: function (value, opt_displayValue, opt_needTriggerResult) {
      this._data.value = value;
      if (opt_displayValue) this._data.displayValue = opt_displayValue;
      this.touch();
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#setValue
    * @param value {string} Устанавливаемое значение реквизита
    * @param [opt_displayValue] {string} Отображаемое значение реквизита
    * @param [opt_needTriggerResult] {boolean} Признак необходимости вызова триггера события change
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;
      if (_.isUndefined(value)) return this;
      if (opt_displayValue && opt_displayValue[0] === '$') opt_displayValue = opt_displayValue.replace('$');

      opt_needTriggerResult = (opt_needTriggerResult !== false); //если не передан, то по умолчанию будет true.
      if (this.controls.length === 0) return this._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);

      var val = opt_displayValue || value;
      var jControl;
      for (var i = 0; i < this.controls.length; i++) {
        jControl = this.controls[i];
        jControl.val(val);
        if (opt_displayValue) {
          jControl.attr("title", opt_displayValue);
        } else {
          jControl.removeAttr('title');
        }
        if (opt_needTriggerResult) { jControl.change(); }
      };

      this.touch();
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает отображаемое значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#setDisplayValue
    * @param value {string} Устанавливаемое значение реквизита
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    setDisplayValue: function (value) {
      this.setValue(this.getValue(), value);
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Делает реквизит недоступным для изменения.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#disable
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    disable() {            
      $(this.controls).each((index, jControl) => {
        this._disableControl(jControl);
      });
      this._isDisabled = true;
      return this;
    },   
    //---------------------------------------------------------------------//

    /**
    * Делает реквизит доступным для изменения.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#enable
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    enable() {      
      $(this.controls).each((index, jControl) => {
        this._enableControl(jControl);
      });
      this._isDisabled = false;
      return this;
    },

   /**
   * Делает контролы реквизита недоступным для изменения, не меняя внутреннее свойство _isDisabled.
   *
   * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_disableControls   
   * @internal
   * @since 5.7.0
   */
    _disableControls() {
      $(this.controls).each((index, jControl) => {
        this._disableControl(jControl);
      });
      return this;
    },

    /**
   * Делает контролы реквизита доступным для изменения, не меняя внутреннее свойство _isDisabled.
   *
   * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_enableControls   
   * @internal
   * @since 5.7.0
   */
    _enableControls() {      
      if (!this._isDisabled) {
        $(this.controls).each((index, jControl) => {
          this._enableControl(jControl);
        });
      }
      return this;
    },

    /**
   * Признак недоступности реквизита для изменения.
   *
   * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isDisabled
   * @return {boolean} True – реквизит недоступен для изменения, иначе False.
   * @since 5.0.0.7100
   */
    isDisabled() {
      let isDisabled = false;
      $(this.controls).each((index, jControl) => {
        isDisabled = jControl.hasClass('Req_Disabled');
      });
      return isDisabled;
    },
    //---------------------------------------------------------------------//

    /**
    * Отключение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_disableControl
    * @private
    * @since 5.0.0.7100
    */
    _disableControl(jControl) {
      jControl.attr('readonly', 'readonly').addClass("Req_Disabled").attr('tabindex', -1);
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Включение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_enableControl
    * @private
    * @since 5.0.0.7100
    */
    _enableControl(jControl) {
      jControl.removeAttr('readonly').removeClass("Req_Disabled").removeAttr('tabindex');;
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Скрывает реквизит и его подпись.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#hide
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    hide: function () {
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i].parents('.Card_Element:first, tr');
        jControl.add(jControl.prev('.CardForm_Label')).css('visibility', "hidden");
      };
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Отображает реквизит и его подпись.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#show
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    show: function () {
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i].parents('.Card_Element:first, tr');
        jControl.add(jControl.prev('.CardForm_Label')).css('visibility', "visible");
      };
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Очищает значения реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#clear
    * @param [opt_needTriggerResult] {boolean} Признак необходимости вызова события change
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.0.0.7100
    */
    clear: function (opt_NeedTriggerResult) {
      this.setValue("", "", opt_NeedTriggerResult);
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Добавляет иконку к элементу управления реквизита, за исключением реквизитов типа «Справочник» и «Множественный выбор».
    * Метод прикрепляет к тестовому полю действие для события, например, нажатие на иконку.
    * При наступлении этого события в код передаются данные о текущем реквизите.
    *
    * @function WebAccess.components.wrappers.form.requisites.BaseRequisite#setCustomAction
    * @param {string} reqName Имя реквизита
    * @param {string} tooltip Подсказка к реквизиту
    * @param {function} callback Функция, которая будет вызвана после нажатия на иконку реквизита.
    * В эту функцию первым параметром будет отправлена информация о реквизите.
    */
    setCustomAction: function (callback, opt_tooltip) {
      opt_tooltip = "" || opt_tooltip;
      var me = this;
      if (this.controls.length === 0) return this;

      //TODO Вынести в соответсвующие классы реквизитов.

      for (var i = 0; i < this.controls.length; i++) {
        var jReq = this.controls[i];
        var instance = jReq.data("ReferenceSelectInstance");

        if (instance) {
          //Для реквизита типа справочник или мультивыбор
          var jReqIcon = jReq.parents(".rs_SelItems_cont").next(".Req_Icon");
          jReqIcon.unbind();
          jReqIcon.click(function () {
            var reqObj = {
              "name": me.name,
              "value": me.getValue(),
              "displayValue": me.getDisplayValue()
            };
            callback(reqObj);
          });
        } else {
          var jReq = this.controls[i].parent("span, div");
          if (jReq.length > 0) {
            // Для текстового реквизита
            var jReqInput = this.controls[i];
            jReqInput.removeClass("text_align_right");

            jReq.prepend(format('<div class="input__icon Req_Icon RefSelect_Arrow rs_img customAction" title="{0}"> </div>', opt_tooltip));
            jReq.children(".Req_Icon").click(function () {
              var reqObj = {
                "name": me.name,
                "value": me.getValue(),
                "displayValue": me.getDisplayValue()
              };
              callback(reqObj);
            });
          } else WebAccess.raise("ERR_REQUISTE_NOT_FOUND_OR_IS_UNSUPPORTED");
        }
      }
    },
    //---------------------------------------------------------------------//

    /**
    * При смене значения в одном контроле оно должно примениться ко всем.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindMirrors
    * @private
    * @since 5.0.0.7100
    */
    _bindMirrors: function () {
      var me = this;
      if (me.controls.length > 1) {
        me.bind('change', function (context, ev, data) {
          me.setValue(data.value, data.displayValue, false);
        });
      }
      return this;
    },

    //---------------------------------------------------------------------//

    /**
    * Признак обязательного заполнения реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isRequired
    * @return {boolean} True – реквизит обязателен для заполнения, иначе False.
    * @since 5.0.0.7100
    */
    isRequired: function () {
      return this._data.isRequired;
    },
    //---------------------------------------------------------------------//

    /**
    * Подсвечивает реквизит.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#highlight
    * @param {string} [opt_color] Цвет поля, в котором указывается значение реквизита. Цвет указывается в виде десятичного или шестнадцатеричного числа.
	  * Рамка поля всегда окрашивается в красный цвет
    * @param {integer} [opt_speed] Длительность подсвечивания поля, в котором указывается значение реквизита. Чем больше число, тем дольше поле подсвечивается
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.1300
    */
    highlight: function (opt_color, opt_speed) {
      var me = this;
      var speed = opt_speed || 300;

      var blink = function (jObject) {
        var prevColor = jObject.css('backgroundColor');
        var prevBorder = jObject.css('borderColor'); //Почему-то не работает

        var highlight = "#F6DADA";

        if (opt_color) {
          var colorLuminance = function (hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '');
            if (hex.length < 6) {
              hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            lum = lum || 0;

            // convert to decimal and change luminosity
            var rgb = "#", c, i;
            for (i = 0; i < 3; i++) {
              c = parseInt(hex.substr(i * 2, 2), 16);
              c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
              rgb += ("00" + c).substr(c.length);
            }
            return rgb;
          }
          jObject.animate({ backgroundColor: colorLuminance(opt_color, .4), borderColor: opt_color }, speed, function () {
            $(this).animate({ backgroundColor: prevColor, borderColor: prevBorder }, speed);
          });
        } else {
          jObject.addClass('Req_Error').animate({ backgroundColor: highlight }, 300, function () {
            $(this).animate({ backgroundColor: prevColor }, speed);
          });
        }
        return jObject;
      };

      for (var j = 0; j < me.controlsIds.length; j++) {
        (function (index) {
          var reqSelector = me.controlsIds[index];
          if (!reqSelector) return;

          var jEl = me._getJElementForHighlight(reqSelector);
          if (jEl) {
            blink(jEl);
          }
        })(j);
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Снимает подсветку с реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#unHighlight
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.2008
    */
    unHighlight: function () {
      var me = this;

      for (var j = 0; j < me.controlsIds.length; j++) {
        var reqSelector = me.controlsIds[j];
        if (!reqSelector) continue;

        var jEl = me._getJElementForHighlight(reqSelector);
        if (jEl) {
          jEl.removeClass('Req_Error')
            .css('borderTopColor', '')
            .css('borderBottomColor', '')
            .css('borderLeftColor', '')
            .css('borderRightColor', ''); // Просто borderColor не получить http://stackoverflow.com/questions/9915966/jquery-cssborder-color-does-not-return-anything
        }
      }

      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Возвращает элемент для подсветки.
    * @private
    */
    _getJElementForHighlight: function (reqSelector) {
      var reqChild = $('#' + reqSelector).find('input,textarea');
      if (reqChild.length > 0) {
        // Если реквизит текстовый
        return reqChild;
      } else {
        if (typeof (reqSelector) != "undefined") {
          // Если реквизит типа справочник
          var reqRef = $('#' + reqSelector);
          if (reqRef.length > 0) {
            var fakeInput = reqRef.parent().parent().parent().find('input.fakeInput:first');
            if (fakeInput.length > 0) {
              return fakeInput;
            } else {
              return reqRef;
            };
          };
        } else {
          // Если реквизит типа справочник в детальном разделе
          var fakereq = $('div[name="' + reqs[i] + '"]');
          if (fakereq.length > 0) {
            return fakereq.find('input.fakeInput');
          };
        }
      }
      return null;
    },

    /**
    * Устанавливает признак isChanged в состояние true.
    * Не вызывает срабатывания событий change.
    *
	* @method WebAccess.components.wrappers.form.requisites.BaseRequisite#touch
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.1300
    */
    touch: function () {
      this._isChanged = true;
      this._isCommited = false;
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает признак isChanged в состояние false.
	*
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#setUntouched
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.2.0.2014
    */
    setUntouched: function () {
      this._isChanged = false;
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Устанавливает признак isCommited в состояние true.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#commit
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит.
    * @since 5.7.0.1000
    */
    commit: function () {
      this._isCommited = true;
      return this;
    },


    /**
    * Получает строковое представление реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#asString
    * @overrides BaseObject.asString
    * @return {string} Строковое представление реквизита.
    * @since 5.0.0.7100
    */
    asString: function () {
      var me = this;
      return $.toJSON({
        name: me.name,
        fullName: me.fullName,
        value: me.getValue(),
        displayValue: me.getDisplayValue()
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает строку детального раздела, к которой относится реквизит.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#getRow
    * @return {WebAccess.components.wrappers.form.BaseTableLine} Строка детального раздела.
    */
    getRow: function () {
      var row = null;
      if (typeof this._parent.getTable !== 'undefined') {
        var table = this._parent.getTable();
        if (typeof table !== 'undefined') {
          row = table.rows[this._parent.id];
        }
      }

      return row;
    },

    /**
     * Получить список контролов с их SBRte-именами.
     *
     * @return {Object} Cписок контролов с их SBRte-именами.
     * @private
     */
    _getSbrteControls() {
      return this.controls.reduce((dictionary, jControl) => {
        const sbrteControlName = jControl.closest('div.Card_Element').attr('name');
        dictionary[sbrteControlName] = jControl;
        return dictionary;
      }, {});
    }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  }, {
    /**
    * Срабатывает после изменения реквизита.
	  *
    * @event WebAccess.components.wrappers.form.requisites.BaseRequisite.EVENT.AFTER_CHANGE
    * @param {WebAccess.components.wrappers.form.requisites.BaseRequisite} Наследник объекта типа BaseRequisite в зависимости от того, к какому классу относится реквизит
    * @param {Event} event Исходное событие (оставлено для обратной совместимости с CardForm)
    * @param {Object} values Значение реквизита
    * @since 5.2.0.2014
    */
    EVENT: {
      AFTER_CHANGE: 'change',


      /**
      * Событие срабатывает, если данные в реквизите были изменены.
      *
      * @event WebAccess.components.wrappers.form.requisites.BaseRequisite.EVENT.CHANGE
      * @param {object} context Ссылка на экземпляр класса
      * @since 5.5.0.2201
      */
      CHANGE: 'change'
    }
  });

  global.WA.CMP.wrappers.form.requisites.BaseRequisite = BaseRequisite;
})(window);
